"use strict";
/* eslint-disable no-console */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogMethods = void 0;
var createLogMethods = function () {
    return {
        debug: console.debug.bind(console),
        error: console.error.bind(console),
        fatal: console.error.bind(console),
        info: console.info.bind(console),
        trace: console.debug.bind(console),
        warn: console.warn.bind(console),
    };
};
exports.createLogMethods = createLogMethods;
